"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceSizeCellRenderer = exports.INSTANCE_SIZE_CELL_SIZES = void 0;
const components_1 = require("@veeam/components");
const trimmedTextRenderer_1 = require("@veeam/components/lib/Grid/cellRenderers/trimmedTextRenderer");
require("../../../core");
const helpers_1 = require("../../../helpers");
require("../types");
require("./types");
var INSTANCE_SIZE_CELL_SIZES;
(function (INSTANCE_SIZE_CELL_SIZES) {
    INSTANCE_SIZE_CELL_SIZES["MB"] = "MB";
    INSTANCE_SIZE_CELL_SIZES["GB"] = "GB";
    INSTANCE_SIZE_CELL_SIZES["TB"] = "TB";
})(INSTANCE_SIZE_CELL_SIZES = exports.INSTANCE_SIZE_CELL_SIZES || (exports.INSTANCE_SIZE_CELL_SIZES = {}));
const instanceSizeCellRenderer = (_a = {}) => {
    var { headerJustify = components_1.GRID_COLUMN_HEADER_JUSTIFY.right, zeroValueSize = INSTANCE_SIZE_CELL_SIZES.GB } = _a, otherConfigProps = __rest(_a, ["headerJustify", "zeroValueSize"]);
    return (_a) => {
        var { cellData } = _a, otherProps = __rest(_a, ["cellData"]);
        const numValue = Number(cellData);
        const value = typeof numValue === 'number' ? numValue : 0;
        let formattedValue;
        if (value === 0) {
            formattedValue = `0 ${zeroValueSize}`;
        }
        else if (value > 0 && value < 1) {
            formattedValue = `${helpers_1.floor(value * 1024, 2)} ${INSTANCE_SIZE_CELL_SIZES.MB}`;
        }
        else if (value < 1024) {
            formattedValue = `${helpers_1.floor(value, 2)} ${INSTANCE_SIZE_CELL_SIZES.GB}`;
        }
        else {
            formattedValue = `${helpers_1.floor(value / 1024, 2)} ${INSTANCE_SIZE_CELL_SIZES.TB}`;
        }
        return trimmedTextRenderer_1.trimmedTextRenderer(Object.assign(Object.assign(Object.assign({}, otherProps), otherConfigProps), { headerJustify, cellData: formattedValue }));
    };
};
exports.instanceSizeCellRenderer = instanceSizeCellRenderer;
//# sourceMappingURL=instanceSizeCellRenderer.js.map